import Axios from "axios"


export async function check_apply(props) {
    const consumer_id = props['consumer_id']
    const Set_info = props['Set_info']
    const isMounted = props['isMounted']

    const result = await Axios
                    .post("/consumer/load", {
                        consumer_id: consumer_id
                    })
    const data = result['data']

    if(data['status'] === 'fail') {
        alert(data['message'])
        window.location.replace("/")
    }
    else if(data['status'] === 'success') {
        const info = data['info']
        const order = data['order']

        Set_info({...info, ...order})

        if(isMounted) {
            isMounted.current++
        }
    }
}